'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bidIncrements = require('./remote/bidIncrements');

var BidIncrements = {
    fetchBidIncrements: _bidIncrements.BidIncrementsRemote.fetchBidIncrements
};

exports.default = BidIncrements;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/bidIncrements.js
// module id = 795h
// module chunks = 60